import type React from 'react';
import * as st from './Spinner.module.scss';

const Spinner: React.FC = () => {
	return <div className={st.spinner} />;
};

export default Spinner;
